module.exports = __webpack_public_path__ + "img/877C72_B6ACBB_36322D_4C443B-256px.95b14bba.png";